Apt.fn.make('payment', {
	/**
	 * Initialize module
	 *
	 * @param {$} target
	 * @param {Object} model
	 * @returns {Object}
	 */
	init(target, model) {
		const priv = this.$private;
		const price = model.price || 100000;
		const down = model.down === 'undefined' ?
			20 : model.down;
		const term = model.term || 180;
		const standard = LS.util.getRates(model.structure);

		const rates = Object.keys(standard).map(key => {
			return {
				value: key,
				label: `${key / 12} ${LS.util.plural('year', key / 12)}`,
				rate: standard[key]
			};
		});

		priv.rates = LS.util.key(rates, 'value');

		let custom;
		let rate = model.rate;

		if (typeof rate !== 'undefined') {
			priv.rates[term] = custom = {
				value: term,
				label: `${term} ${LS.util.plural('month', term)}`,
				rate: model.rate
			};
		} else {
			rate = standard[term];
		}

		priv.uid = LS.util.uid();

		$(target).html($.view.render('payment.view', {
			price: price,
			down: Math.round(price * (down / 100)),
			down_percent: down,
			term: term.toString(),
			custom: custom,
			rates: rates,
			rate: rate,
			tax: model.tax || Math.round(price * model.tax_rate || 0.07),
			taxEst: Boolean(model.tax_rate),
			expense: model.expense || 0
		}));

		priv.app = $.app.make('payment', {
			view: 'payment._output',
			target: '$paymentOutput'
		});

		const form = $$('paymentForm')[0];

		if (model.price) {
			form.price_slider.max = model.max || Math.round(model.price * 1.5);
		}

		form.price_slider.value = price;

		priv.update();
		priv.bind();

		return this;
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		const priv = this.$private;

		priv.app.$destroy();

		$.events.reset(priv.uid);
	}
}, {
	/**
	 * Bind events
	 */
	bind() {
		const scope = this;
		const $form = $$('paymentForm');
		const form = $form[0];
		const config = {
			namespace: scope.uid
		};

		LS.util.restrict('[inputmode]', null, scope.uid, $form);

		$(form.price).on('input', (e, el) => {
			const value = LS.util.parseNumber(el.value || 0);

			form.price.value = LS.util.formatNumber(value);
			form.price_slider.value = value;
			form.down.value = LS.util.formatNumber(value * (form.down_percent.value / 100));

			scope.update();
		}, config);

		$(form.price_slider).on('input', (e, el) => {
			const value = el.value;

			form.price.value = LS.util.formatNumber(value);
			form.down.value = LS.util.formatNumber(value * (form.down_percent.value / 100));

			scope.update();
		}, config);

		$(form.down).on('input', (e, el) => {
			const price = LS.util.parseNumber(form.price.value);

			let down = LS.util.parseNumber(el.value || 0);
			let percent;

			if (down > price) {
				down = price;
			}

			percent = Math.round((down / price) * 10000) / 100;

			form.down.value = LS.util.formatNumber(down);
			form.down_percent_slider.value = form.down_percent.value = percent;

			scope.update();
		}, config);

		$(form.down_percent).on('input', (e, el) => {
			if (el.value > 100) {
				el.value = 100;
			} else if (el.value < 0) {
				el.value = 0;
			}

			form.down.value = LS.util.formatNumber(
				LS.util.parseNumber(form.price.value) * (el.value / 100)
			);
			form.down_percent_slider.value = el.value;

			scope.update();
		}, config);

		$$(form.down_percent_slider).on('input', (e, el) => {
			const value = el.value;
			const price = LS.util.parseNumber(form.price.value);

			form.down.value = LS.util.formatNumber(price * (value / 100));
			form.down_percent.value = value;

			scope.update();
		}, config);

		$(form.term).on('input', (e, el) => {
			form.rate.value = scope.rates[el.value].rate;

			scope.update();
		}, config);

		$(form.rate).on('input', (e, el) => {
			if (el.value > 100) {
				el.value = 100;
			} else if (el.value < 0) {
				el.value = 0;
			}

			scope.update();
		}, config);

		$([
			form.taxes,
			form.expenses
		]).on('input', (e, el) => {
			el.value = LS.util.formatNumber(el.value);

			scope.update();
		}, config);
	},

	/**
	 * Update calculation
	 */
	update() {
		const scope = this;
		const model = scope.model();

		scope.app.$set(model);

		scope.chart([
			model.loan_payment,
			model.tax_payment,
			model.expenses
		]);
	},

	/**
	 * Build model
	 *
	 * @returns {Object}
	 */
	model() {
		const data = $$('paymentForm').serialize(true);
		const price = LS.util.parseNumber(data.price);
		const down = LS.util.parseNumber(data.down);
		const rate = (data.rate / 12) / 100;
		const loan_monthly = rate ?
			(rate * Math.max(price - down, 0)) / (1 - (Math.pow((1 + rate), -data.term))) :
			(price - down) / data.term;
		const taxes_monthly = LS.util.parseNumber(data.taxes) / 12;
		const expenses = LS.util.parseNumber(data.expenses);
		const total = loan_monthly * data.term;
		const loan = Math.max(price - down, 0);

		return {
			expenses: expenses,
			interest: Math.round(total - loan),
			loan: loan,
			loan_payment: Math.round(loan_monthly),
			payment: Math.round(loan_monthly + taxes_monthly + expenses),
			tax_payment: Math.round(taxes_monthly),
			total: Math.round(total)
		};
	},

	/**
	 * Chart values
	 *
	 * @param {Array} values
	 */
	chart(values) {
		const circles = $('circle', '$paymentChart');
		const total = values.reduce((total, value) => total + value, 0);

		let sum = 0;

		values.forEach((value, index) => {
			const percent = (value / total) * 100;

			circles[index].style.strokeDasharray = percent + ' ' + (100 - percent);
			circles[index].style.strokeDashoffset = (index ? 100 - sum : 0) + 45;

			sum += percent;
		});
	}
});